import { useAuth } from '@modules/auth/hooks';
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { STUDY_INSIGHTS_SEQUENCED_SAMPLES_OVERVIEW_QUERY_KEY } from '../constants/api';
import { fetchSequencedSamplesOverview } from '@modules/study-insights/services/overview.service';
import { SequencedSamplesOverview } from '../types/overview.types';
import { FetchSequencedSamplesOverviewParam } from '../types/sequenced-samples.types';

const useQuerySequencedSamplesOverview = <TError = unknown>(
  { studyId, ...params }: FetchSequencedSamplesOverviewParam = {},
  options?: Omit<
    UseQueryOptions<SequencedSamplesOverview | undefined, TError, SequencedSamplesOverview, string[]>,
    'initialData' | 'queryFn' | 'queryKey'
  >,
): UseQueryResult<SequencedSamplesOverview> => {
  const { isAuthenticated } = useAuth();

  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;

  return useQuery(
    [STUDY_INSIGHTS_SEQUENCED_SAMPLES_OVERVIEW_QUERY_KEY],
    async () => await fetchSequencedSamplesOverview(studyId, params),
    {
      ...options,
      enabled: isAuthenticated === true && enabledOption,
    },
  );
};
export default useQuerySequencedSamplesOverview;
